import { cn } from "@btnet/utilities-core";

import TextTruncate from "commonComponents/utilities/TextTruncate/TextTruncate";

import "./SplitRowWithDotLeader.less";

interface ISplitRowWithDotLeaderProps {
    left: string | React.ReactNode;
    right: string | React.ReactNode;
    leaderType: "dashed" | "dotted";
    className?: string;
    showPopover?: boolean;
}

export const SplitRowWithDotLeader: React.FC<ISplitRowWithDotLeaderProps> = ({
    left,
    right,
    leaderType = "dotted",
    className,
    showPopover = false,
}) => {
    return (
        <div className={cn("SplitRowWithDotLeader", className)}>
            <div className="TextAndLine">
                <TextTruncate showPopover={showPopover}>
                    <span>{left}</span>
                </TextTruncate>
                <span className={`DottedLine ${leaderType}`} />
                <TextTruncate showPopover={showPopover}>
                    <span>{right}</span>
                </TextTruncate>
            </div>
        </div>
    );
};
